import React, {useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../_metronic/helpers'
import * as Yup from 'yup'
import useUtils from './useUtils'
import {Formik} from 'formik'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'
import {showAlert} from '../../redux/reducers/alertSlice'
import {useDispatch} from 'react-redux'

type Props = {
  show: boolean
  handleClose: () => void
  category?: any
  limit: any
  offset: any
  setCategories: any
  type?: any
  setType?: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

function EditCategory({
  show,
  handleClose,
  category,
  limit,
  offset,
  setCategories,
  type,
  setType,
}: Props) {
  const {handleEdit, submitcategory} = useUtils()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const initialValues = {
    name: category?.name || '',
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Category is required'),
  })

  const submit = async (values: any) => {
    try {
      if (type === 'add') {
        const result = await submitcategory({name: values.name},handleClose, limit, offset)
          setCategories(result)
      } else {
        const result = await handleEdit(values.name, category?.id, handleClose, limit, offset)
        setCategories(result)
      }
    } catch (error: any) {
      console.log(error)
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network Error',
          variant: 'danger',
        })
      )
      handleClose()
    }
  }

  const handleSubmit = (values: any) => {
    submit(values)
  }

  return createPortal(
    <>
      <Modal
        id='kt_modal_create_app'
        aria-hidden='true'
        dialogClassName=' modal-dialog-centered '
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>{type == 'add' ? 'Add Category' : 'Edit Category'}</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, errors, touched, handleChange, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='modal-body px-lg-10'>
                <div className='tab-content'>
                  {/* end::Body */}
                  <div className='row align-items-center flex-wrap'>
                    <div className='col'>
                      <label className='col-form-label required fw-bold fs-6'>Category</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-lg-0'
                        placeholder='name'
                        name='name'
                        value={values.name}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.name ? 'Name is required' : ''}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center  justify-content-end mt-7'>
                  <button type='button' className='btn btn-danger ms-2  me-2' onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type='button'
                    onClick={() => {
                      if (type === 'add') {
                        document.querySelector('form')?.requestSubmit()
                      } else {
                        setIsOpen(true)
                      }
                    }}
                    className='btn btn-primary ms-2  me-2'
                  >
                    {type == 'add' ? 'Create' : 'Update'}
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
      <AssignConfirmation
        isVisible={isOpen}
        message='Are you sure you want to update this category?'
        onConfirm={() => {
          setIsOpen(false)
          setType('')
          setTimeout(() => {
            document.querySelector('form')?.requestSubmit() // Triggers form submission
          }, 0)
        }}
        onCancel={() => {
          setIsOpen(false)
          setType('')
        }}
      />
    </>,
    modalsRoot
  )
}

export default EditCategory
